import React from 'react';
import { Link } from 'gatsby';

import ATCLogo from 'images/atc.svg';

import { indexSolutions, socialLinks } from 'utils/contentProvider';

import {
  FooterSection,
  FooterMenuList,
  FooterCopyright,
} from './Footer.styled';

const Footer = () => (
  <FooterSection>
    <div className="container">
      <div className="row">
        <div className="col-md-3 footer-links-area">
          <h4>Solutions</h4>
          <FooterMenuList>
            {indexSolutions.map((i) => (
              <li key={i.id}>
                <Link to={i.link}>{i.title}</Link>
              </li>
            ))}
          </FooterMenuList>
        </div>
        <div className="col-6 col-md-2 footer-links-area">
          <h4>Company</h4>
          <FooterMenuList>
            {/* <li>
              <Link to="/partners/">Partners</Link>
            </li> */}
            <li>
              <Link to="/trainings/">Training</Link>
            </li>
            <li>
              <Link to="/about-us/">About</Link>
            </li>
            <li>
              <Link to="/careers/">Careers</Link>
            </li>
            <li>
              <Link to="/contact-us/">Contact Us</Link>
            </li>
            <li>
              <Link to="/atc-ventures/">Ventures</Link>
            </li>
          </FooterMenuList>
        </div>
        <div className="col-6 col-md-2 footer-links-area">
          <h4>Resources</h4>
          <FooterMenuList>
            <li>
              <a href="https://blog.american-technology.net/">Blog</a>
            </li>
            <li>
              <a href="https://blog.american-technology.net/videos/">Videos</a>
            </li>
            <li>
              <a href="https://blog.american-technology.net/webinars/">
                Webinars
              </a>
            </li>
            <li>
              <a href="https://blog.american-technology.net/whitepapers/">
                Whitepapers
              </a>
            </li>
          </FooterMenuList>
        </div>
        <div className="col-md-3 offset-md-1">
          <ATCLogo width="69px" className="atc-logo" />
          <p className="about">
            To follow our latest news, chat with the community, chat with us,
            post a sweet word:
          </p>
          <div className="social">
            <a
              href={socialLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href={socialLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href={socialLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </div>
        </div>
      </div>
      <FooterCopyright>
        {/* <div className="list">
          <p data-num="1. " style={{ maxWidth: 1000 }}>
            For businesses organized as a limited liability company or
            corporation, we do not perform a hard credit pull at any point in
            our process, which means your credit score will not be impacted. For
            businesses organized as sole proprietors or general partnerships, we
            will only perform a hard credit pull after you receive and accept
            your offer.
          </p>
          <p data-num="2.">
            The rate is a simple interest rate calculated from total repayments
            over 26 weeks.
          </p>
        </div> */}
        <p className="copyright">
          &copy;
          {` ${new Date().getFullYear()} `}
          ATC. All Rights Reserved.&nbsp;
          <Link to="/privacy-policy/" className="pink">
            Privacy Policy
          </Link>
        </p>
      </FooterCopyright>
    </div>
  </FooterSection>
);

export default Footer;
